import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import ConfirmationButton from '../../../app/components/ConfirmationButton';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { useTranslation } from '../../../translations';
import AlertModal from '../../../app/components/AlertModal';

export const SymphonyResendLink = (props: {
  salesInvoiceId?: string | null;
  modificationDate?: Date | null;
}) => {
  const pok = usePokCore();
  const notifications = useNotifications();
  const { t, tk } = useTranslation('fvsLng');
  const [warning, setWarning] = useState<string | null>(null);
  const [info, setInfo] = useState('');
  const [showInfo, setShowInfo] = useState(false);

  useEffect(() => {
    if (props.salesInvoiceId) {
      pok.salesInvoicesGetById
        .getById(props.salesInvoiceId)
        .then(salesInvoice => {
          if (
            salesInvoice &&
            props.modificationDate &&
            salesInvoice.sentToSymphonyHandelTs &&
            salesInvoice.sentToSymphonyHandelTs > props.modificationDate
          ) {
            setWarning(t(tk.symphony.warningResend));
          } else {
            setWarning(null);
          }
        })
        .catch(async errorResponse => {
          notifications.caughtError(errorResponse);
        });
    }
  }, [props, pok.salesInvoicesGetById, notifications, t, tk]);

  const handleClick = () => {
    if (props.salesInvoiceId) {
      pok.symphonies
        .resendInvoiceToSymphony(props.salesInvoiceId)
        .then(() => {
          setInfo(t(tk.symphony.sendingFVSToSymfoniaFinished));
          setShowInfo(true);
        })
        .catch(async errorResponse => {
          notifications.caughtError(errorResponse);
        });
    }
  };

  return (
    <>
      <ConfirmationButton
        className="ms-1"
        confirmation={`${t(tk.symphony.askResendToSymphony)}`}
        warnings={warning ? [warning] : []}
        variant="btn-info"
        onOK={handleClick}
      >
        <OverlayTrigger
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {t(tk.symphony.resendToSymphony)}
            </Tooltip>
          }
        >
          <Icon.ArrowClockwise size={16} />
        </OverlayTrigger>
      </ConfirmationButton>
      <AlertModal
        variant="info"
        buttonText={t(tk.button.close)}
        buttonVariant="outline-success"
        size="lg"
        show={showInfo}
        onHide={() => {
          setShowInfo(false);
        }}
      >
        {info}
      </AlertModal>
    </>
  );
};
